import React, { FC, useEffect, useMemo, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import Select from 'react-select'
import { fetchData, getEncryptedRoute, toasterrormsg, toastsuccessmsg, useMenuIdPermissions } from '../../../reusable'
import { ToastContainer } from 'react-toastify'
import { AddSpaceHeader } from './AddSpaceHeader'
import moment from 'moment'
import JoditEditor from 'jodit-react'
import { config } from '../../../reusable'
import Flatpickr from 'react-flatpickr'
import 'flatpickr/dist/flatpickr.min.css'
import { Tr } from '../../../_metronic/i18n/Tr'

const AddSpacePolicies: FC = () => {
  let t = Tr()
  const navigate = useNavigate()
  const { menuId } = useMenuIdPermissions()
  
 const tmp = sessionStorage.getItem('admin')
const adminId = tmp ? JSON.parse(tmp)?.adminId ?? '' : ''

  const divRefEN = useRef(null) as any
  const divRefRU = useRef(null) as any
  const divRefUZ = useRef(null) as any

  const location = useLocation()
  const editSpacerentalId = (location.state as any)?.spacerentalId || ''
  const primaryLanguage = sessionStorage.getItem('primaryLanguage')
  const [spaceRenatalDetails, setSpacerentalDetails] = useState([])
  const [tab, setTab] = useState('1')

  var vendorId = ''
  const vendorData = sessionStorage.getItem('vendor')
  if (vendorData) {
    var vendor = JSON.parse(vendorData)
    vendorId = vendor.vendorId
  } else {
  }
  const editorRef = useRef(null)
  const editorConfig = useMemo(() => config(), [])
  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false)
  const [cancellationPolicyId, setCancellationPolicyId] = useState('')
  const [cancellationPolicyEN, setCancellationPolicyEN] = useState('')
  const [cancellationPolicyRU, setCancellationPolicyRU] = useState('')
  const [cancellationPolicyUZ, setCancellationPolicyUZ] = useState('')
  const [userGuideEN, setUserGuideEN] = useState('')
  const [userGuideRU, setUserGuideRU] = useState('')
  const [userGuideUZ, setUserGuideUZ] = useState('')
  const [isNonRefundable, setIsNonRefundable] = useState(true)
  const [apiTabs, setApiTabs] = useState(new Set()) as any
  const [apiData, setApiData] = useState({}) as any // Stores original API data per tab

  const handleNonRefundableChange = (e: any) => {
    setIsNonRefundable(e.target.checked) // Toggle the checked state
  }
  const getInitialBeforeCheckinDaysList = (tab: any) => {
    if (tab === '1') {
      return [{ value: '0', label: 'less than 24 hours' }]
    } else if (tab === '5') {
      return createDaysList(4)
    } else if (tab === '14') {
      return createDaysList(13)
    } else if (tab === '30') {
      return createDaysList(29)
    } else {
      return []
    }
  }

  const createDaysList = (days: any) => {
    const list = []
    for (let i = days; i >= 0; i--) {
      list.push({
        value: i.toString(),
        label: i === 0 ? 'less than 24 hours' : `${i} Days`,
      })
    }
    return list
  }

  useEffect(() => {
    setCancellationDay([{ cancellationDay: tab, fee: fee }])
  }, [tab])

  useEffect(() => {
    // Only update `fee` and `cancellationDay` when switching tabs if the current tab isn't from the API
    if (apiTabs.has(tab) && apiData[tab]) {
      // If the tab has data from the API, use the stored API data
      setFee(apiData[tab].fee)
      setCancellationDay(apiData[tab].cancellationDay)
    } else {
      // If it's not an API tab, set the default values
      const defaultFee =
        tab === '5' || tab === '14' || tab === '30'
          ? [
            { day: '0', percentage: '' },
            { day: '1', percentage: '' },
          ]
          : [{ day: '0', percentage: '' }]

      const defaultCancellationDay = {
        cancellationDay: tab,
        fee: defaultFee,
      }

      setFee(defaultFee)
      setCancellationDay([defaultCancellationDay])
    }
  }, [tab, apiTabs])

  const initialPercentageList = [
    { value: '100', label: '100% of the total price' },
    { value: '90', label: '90% of the total price' },
    { value: '70', label: '70% of the total price' },
    { value: '50', label: '50% of the total price' },
  ]
  const [showPolicy, setShowPolicy] = useState(false)

  const togglePolicy = () => {
    setShowPolicy(!showPolicy)
  }

  const [fee, setFee] = useState([{ day: '', percentage: '' }])
  const [cancellationDay, setCancellationDay] = useState([{ cancellationDay: tab, fee: fee }])

  const handleAddField = () => {
    setFee([...fee, { day: '', percentage: '' }])
  }

  const handleRemoveField = (index: any) => {
    const newFields = fee.filter((_, i) => i !== index)
    setFee(newFields)
    setCancellationDay([{ cancellationDay: tab, fee: newFields }])
  }

  const handleFieldChange = (index: any, field: any, value: any) => {
    const newFields = [...fee] as any
    newFields[index][field] = value
    setFee(newFields)
    setCancellationDay([{ cancellationDay: tab, fee: newFields }])
  }

  const filterDaysList = (fields: any) => {
    const selectedDays = fields.map((f: any) => f.day)
    return getInitialBeforeCheckinDaysList(tab).filter((day) => !selectedDays.includes(day.value))
  }

  const filterPercentageList = (fields: any) => {
    const selectedPercentages = fields.map((f: any) => f.percentage)
    return initialPercentageList.filter(
      (percentage) => !selectedPercentages.includes(percentage.value)
    )
  }
  const [policies, setPolicies] = useState([
    {
      en_title: '',
      ru_title: '',
      uz_title: '',
      en_name: '',
      ru_name: '',
      uz_name: '',
      en_description: '',
      ru_description: '',
      uz_description: '',
    },
  ])

  useEffect(() => {
    if (divRefEN.current) {
      setCancellationPolicyEN(divRefEN.current.innerHTML)
    }
  }, [isNonRefundable, cancellationDay])

  useEffect(() => {
    if (divRefRU.current) {
      setCancellationPolicyRU(divRefRU.current.innerHTML)
    }
  }, [isNonRefundable, cancellationDay])

  useEffect(() => {
    if (divRefUZ.current) {
      setCancellationPolicyUZ(divRefUZ.current.innerHTML)
    }
  }, [isNonRefundable, cancellationDay])
  // set error state
  const [error, setError] = useState([
    {
      cancellationPolicyEN: '',
      cancellationPolicyRU: '',
      cancellationPolicyUZ: '',
      userGuideEN: '',
      userGuideRU: '',
      userGuideUZ: '',
    },
  ])

  const [errors, setErrors] = useState({
    titleEN: '',
    titleRU: '',
    titleUZ: '',
    policyNameEN: '',
    policyNameRU: '',
    policyNameUZ: '',
    descriptionEN: '',
    descriptionRU: '',
    descriptionUZ: '',
  }) as any

  const handleAddPolicy = () => {
    setPolicies([
      ...policies,
      {
        en_title: '',
        ru_title: '',
        uz_title: '',
        en_name: '',
        ru_name: '',
        uz_name: '',
        en_description: '',
        ru_description: '',
        uz_description: '',
      },
    ])
  }

  const handleRemovePolicy = (index: any) => {
    if (policies.length === 1) return // Prevent removing the last row
    const updatedPolicies = policies.filter((_, i) => i !== index)
    setPolicies(updatedPolicies)
    // Clear errors for removed policy
    const updatedErrors = { ...errors } as any
    delete updatedErrors[index]
    setErrors(updatedErrors)
  }

  const handlePolicyChange = (index: any, field: any, value: any) => {
    const updatedPolicies = [...policies] as any
    updatedPolicies[index][field] = value
    setPolicies(updatedPolicies)
    // Clear error when user starts typing
    const updatedErrors = { ...errors } as any
    delete updatedErrors[index]
    setErrors(updatedErrors)
  }

  // remove validation function
  const removeError = (err: any) => {
    var tmp = [...error] as any
    tmp[0][err] = ''
    setError(tmp)
  }
  function getDayNumber(day: any) {
    switch (day.toLowerCase()) {
      case 'monday':
        return 1
      case 'tuesday':
        return 2
      case 'wednesday':
        return 3
      case 'thursday':
        return 4
      case 'friday':
        return 5
      case 'saturday':
        return 6
      case 'sunday':
        return 7
      default:
        return 0 // For any other case
    }
  }
  // validation function
  const validate = () => {
    var isValid = true
    var errorTmp = [...error]

    if (primaryLanguage == 'English') {
      if (
        cancellationPolicyEN.trim() == '' ||
        cancellationPolicyEN.trim() == null ||
        cancellationPolicyEN.trim() == undefined
      ) {
        errorTmp[0].cancellationPolicyEN = t('Cancellation Policy Is Required')
        isValid = false
      }
      if (
        userGuideEN.trim() == '' ||
        userGuideEN.trim() == null ||
        userGuideEN.trim() == undefined
      ) {
        errorTmp[0].userGuideEN = t('User Guide Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Russian') {
      if (
        cancellationPolicyRU.trim() == '' ||
        cancellationPolicyRU.trim() == null ||
        cancellationPolicyRU.trim() == undefined
      ) {
        errorTmp[0].cancellationPolicyRU = t('Cancellation Policy Is Required')
        isValid = false
      }
      if (
        userGuideRU.trim() == '' ||
        userGuideRU.trim() == null ||
        userGuideRU.trim() == undefined
      ) {
        errorTmp[0].userGuideRU = t('User Guide Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Uzbek') {
      if (
        cancellationPolicyUZ.trim() == '' ||
        cancellationPolicyUZ.trim() == null ||
        cancellationPolicyUZ.trim() == undefined
      ) {
        errorTmp[0].cancellationPolicyUZ = t('Cancellation Policy Is Required')
        isValid = false
      }
      if (
        userGuideUZ.trim() == '' ||
        userGuideUZ.trim() == null ||
        userGuideUZ.trim() == undefined
      ) {
        errorTmp[0].userGuideUZ = t('User Guide Is Required')
        isValid = false
      }
    }
    if (showPolicy) {
      const newErrors = {} as any
      policies.forEach((policy: any, index: any) => {
        if (primaryLanguage == 'English') {
          if (!policy.en_title) {
            newErrors[index] = { ...newErrors[index], titleEN: t('Policy Title Is Required') }
            isValid = false
          }
          if (!policy.en_description) {
            newErrors[index] = { ...newErrors[index], descriptionEN: t('Description Is Required') }
            isValid = false
          }
        } else if (primaryLanguage == 'Russian') {
          if (!policy.ru_title) {
            newErrors[index] = { ...newErrors[index], titleRU: t('Policy Title Is Required') }
            isValid = false
          }
          if (!policy.ru_description) {
            newErrors[index] = { ...newErrors[index], descriptionRU: t('Description Is Required') }
            isValid = false
          }
        } else if (primaryLanguage == 'Uzbek') {
          if (!policy.uz_title) {
            newErrors[index] = { ...newErrors[index], titleUZ: t('Policy Title Is Required') }
            isValid = false
          }
          if (!policy.uz_description) {
            newErrors[index] = { ...newErrors[index], descriptionUZ: t('Description Is Required') }
            isValid = false
          }
        }
      })
      setErrors(newErrors)
    }
    setError(errorTmp)
    return isValid
  }

  const [openingHourData, setOpeningHourData] = useState([
    { day: 'MONDAY', isOpen: '0', timeSlot: [{ startTime: '00:00:00', endTime: '00:00:00' }] },
    { day: 'TUESDAY', isOpen: '0', timeSlot: [{ startTime: '00:00:00', endTime: '00:00:00' }] },
    { day: 'WEDNESDAY', isOpen: '0', timeSlot: [{ startTime: '00:00:00', endTime: '00:00:00' }] },
    { day: 'THURSDAY', isOpen: '0', timeSlot: [{ startTime: '00:00:00', endTime: '00:00:00' }] },
    { day: 'FRIDAY', isOpen: '0', timeSlot: [{ startTime: '00:00:00', endTime: '00:00:00' }] },
    { day: 'SATURDAY', isOpen: '0', timeSlot: [{ startTime: '00:00:00', endTime: '00:00:00' }] },
    { day: 'SUNDAY', isOpen: '0', timeSlot: [{ startTime: '00:00:00', endTime: '00:00:00' }] },
  ])

  // const addTimeField = (index: any) => {
  //   const newData = [...openingHourData]
  //   newData[index].timeSlot.push({startTime: '00:00:00', endTime: '00:00:00'})
  //   setOpeningHourData(newData)

  // }

  const addTimeField = (index: number) => {
    const newData = [...openingHourData]

    // If currently closed (no time slots), set isOpen to '1'
    if (newData[index].timeSlot.length === 0) {
      newData[index].isOpen = '1'
    }

    newData[index].timeSlot.push({ startTime: '00:00:00', endTime: '00:00:00' })
    setOpeningHourData(newData)
  }

  const removeTimeField = (dayIndex: number, timeIndex: number) => {
    setOpeningHourData((prev: any) => {
      const newData = [...prev]
      newData[dayIndex].timeSlot.splice(timeIndex, 1)

      // If no time slots left, set isOpen to '0'
      if (newData[dayIndex].timeSlot.length == 0) {
        newData[dayIndex].isOpen = '0'
      }

      return newData
    })
  }

  const handleInputChange = (dayIndex: any, timeIndex: any, event: any) => {
    var { name, value } = event.target
    const parsedTime = moment(value, 'HH:mm')

    // Format the time input to HH:mm:ss
    let formattedValue = parsedTime.isValid() ? parsedTime.format('HH:mm:ss') : ''

    const newData = [...openingHourData] as any

    // Validate start time against end time
    if (name == 'startTime') {
      const endTime = newData[dayIndex].timeSlot[timeIndex].endTime
      if (endTime && formattedValue >= endTime) {
        toasterrormsg('End Time Must be Greater Than Start Time')
        return // Do not update state if validation fails
      }
    } else if (name == 'endTime') {
      const startTime = newData[dayIndex].timeSlot[timeIndex].startTime

      // If endTime is entered as 00:00, replace with 23:45
      if (formattedValue === '00:00:00') {
        formattedValue = '23:45:00'
      }

      if (startTime && formattedValue <= startTime) {
        toasterrormsg('End Time Must be Greater Than Start Time')
        return // Do not update state if validation fails
      }
    }

    // Validate time conflicts
    for (let i = 0; i < newData[dayIndex].timeSlot.length; i++) {
      if (i != timeIndex) {
        const existingStartTime = newData[dayIndex].timeSlot[i].startTime
        const existingEndTime = newData[dayIndex].timeSlot[i].endTime
        if (
          (formattedValue >= existingStartTime && formattedValue < existingEndTime) ||
          (existingStartTime >= formattedValue && existingStartTime < formattedValue)
        ) {
          toasterrormsg('Time Is Conflicting')
          return
        }
      }
    }

    newData[dayIndex].timeSlot[timeIndex][name] = formattedValue
    setOpeningHourData(newData)
  }

  const handleTimeChange2 = (date: any) => {
    if (date && date.length > 0) {
      const selectedTime = moment(date[0]) // Get the first element if date is an array
      if (selectedTime.isValid()) {
        let roundedTime = selectedTime.clone().second(0) // Reset seconds to 0

        if (selectedTime.minute() > 0) {
          // If minutes are greater than 0, always round up to the next hour
          roundedTime = roundedTime.add(1, 'hour').minute(0)
        } else {
          // If minutes are exactly 0, keep the hour as is
          roundedTime = roundedTime.minute(0)
        }

        return roundedTime.format('HH:mm') // Return the rounded time
      } else {
        console.error('Invalid date selected')
      }
    }
    return '00:00' // Default value if no valid date is selected
  }

  // Check if any required fields are not defined or empty
  const isValid = openingHourData.every((opening) => {
    return opening.day && opening.timeSlot.every((slot) => slot.startTime && slot.endTime)
  })
  // add hotel policy api call
  const addSpacePolicies = async () => {
    if (validate()) {
      if (isValid) {
        setDisable(true)
        setLoading(true)

        var param: any = {
          spacerentalId: String(editSpacerentalId),
          en_userGuide: userGuideEN,
          adminId: adminId,
          ru_userGuide: userGuideRU,
          uz_userGuide: userGuideUZ,
          en_cancellationPolicy: cancellationPolicyEN,
          ru_cancellationPolicy: cancellationPolicyRU,
          uz_cancellationPolicy: cancellationPolicyUZ,
          isNonRefundable: isNonRefundable ? '1' : '0',
          openinghours: openingHourData,
        }
        if (showPolicy) {
          param['customPolicy'] = policies
        }
        if (cancellationPolicyId != '') {
          param['cancellationPolicyId'] = String(cancellationPolicyId)
        }
        if (isNonRefundable == false) {
          param['cancellationDay'] = cancellationDay
        }

        var response: any = await fetchData('vendor/public/addSpaceRentalPolicy', param)

        if (response.status == '200') {
          toastsuccessmsg('Policies Added Successfully!')
          const state = {
            spacerentalId: editSpacerentalId,
          }
          setTimeout(() => {
            navigate(getEncryptedRoute('../addspacefinance/', { menuId: menuId }), { state })

            setDisable(false)
          }, 1500)
        } else {
          toasterrormsg(response.message)
          setDisable(false)
          setLoading(false)
        }
      } else {
        toasterrormsg('Please fill in all required fields.')
        setLoading(false)
        return
      }
    }
  }
  // space Details api call
  const spaceDetailsApiCall = async () => {
    var param: any = {
      spacerentalId: String(editSpacerentalId),
    }
    var response: any = await fetchData('vendor/public/spaceDetails', param)

    if (response.status == '200') {
      setSpacerentalDetails(response.data)
      var data = response.data[0]
      setUserGuideEN(data.en_userGuide)
      setUserGuideRU(data.ru_userGuide)
      setUserGuideUZ(data.uz_userGuide)
      setCancellationPolicyId(data.cancellationPolicyId)
      setCancellationPolicyEN(data.en_cancellationPolicy)
      setCancellationPolicyRU(data.ru_cancellationPolicy)
      setCancellationPolicyUZ(data.uz_cancellationPolicy)
      setIsNonRefundable(data.isNonRefundable)
      if (data.cancellationDay.length > 0) {
        const apiTab = data.cancellationDay[0]['cancellationDay']
        setTab(apiTab)
        setFee(data.cancellationDay[0]['fee'])
        setCancellationDay(data.cancellationDay)
        setApiData((prev: any) => ({
          ...prev,
          [apiTab]: {
            fee: data.cancellationDay[0]['fee'],
            cancellationDay: data.cancellationDay,
          },
        }))
        // Mark this tab as API-provided
        setApiTabs(new Set([...apiTabs, apiTab]))
      }

      if (data.customPolicy.length != 0) {
        setShowPolicy(true)
        setPolicies(data.customPolicy)
      }
      if (data['openingHours'].length != 0) {
        var openingHours = data['openingHours'].map((item: any) => {
          return {
            spaceopeninghourId: item.spaceopeninghourId,
            day: item.day,
            isOpen: item.timeSlot.length > 0 ? '1' : '0',
            timeSlot: item.timeSlot,
          }
        })
        // Sort the opening hours based on the day of the week
        openingHours.sort((a: any, b: any) => {
          return getDayNumber(a.day) - getDayNumber(b.day)
        })
        setOpeningHourData(openingHours)
      }
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    if (editSpacerentalId != '') {
      spaceDetailsApiCall()
    }
  }, [])

  // const toggleDayOpen = (dayIndex: any) => {
  //   setOpeningHourData((prev: any) =>
  //     prev.map((day: any, index: any) =>
  //       index === dayIndex ? {...day, isOpen: day.isOpen == '1' ? '0' : '1'} : day
  //     )
  //   )
  // }

  const toggleDayOpen = (dayIndex: number) => {
    setOpeningHourData((prev: any) =>
      prev.map((day: any, index: number) => {
        if (index === dayIndex) {
          const newIsOpen = day.isOpen === '1' ? '0' : '1'
          return {
            ...day,
            isOpen: newIsOpen,
            timeSlot:
              newIsOpen === '1'
                ? [{ startTime: '00:00:00', endTime: '00:00:00' }] // open → add default slot
                : [], // close → clear all slots
          }
        }
        return day
      })
    )
  }
  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>
        {editSpacerentalId != '' ? t('Edit Space Policies') : t('Add Space Policies')}
      </PageTitle>
      <AddSpaceHeader spacerentalId={editSpacerentalId} />
      <div className='d-flex flex-column flex-column-fluid'>
        {/* <!--begin::Content--> */}
        <div id='kt_app_content' className='app-content flex-column-fluid'>
          {/* <!--begin::Form--> */}
          <div className='form d-flex flex-column flex-lg-row'>
            {/* <!--begin::Main column--> */}
            <div className='d-flex flex-column flex-row-fluid gap-7 gap-lg-10'>
              {/* <!--begin::Tab content--> */}
              <div className='tab-content'>
                {/* <!--begin::Tab pane--> */}
                <div
                  className='tab-pane fade show active'
                  id='kt_ecommerce_add_product_general'
                  role='tab-panel'
                >
                  <div className='d-flex flex-column'>
                    {/* <!--begin::General options--> */}
                    <div className='card card-flush py-4'>
                      {/* <!--begin::Card header--> */}
                      <div className='card-header d-flex'>
                        {/* <!--begin::Card title--> */}
                        <div className='card-title'>
                          <h2>{t('Space Policies')}</h2>
                        </div>
                        {/* <!--end::Card title--> */}
                        <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                          {spaceRenatalDetails.length != 0 ? (
                            <>
                              {spaceRenatalDetails.map((completedSteps: any, index: any) => {
                                var percentage = 0
                                if (completedSteps['completedSteps']['basicInfo']) {
                                  percentage = 10
                                }
                                if (completedSteps['completedSteps']['location']) {
                                  percentage = 20
                                }
                                if (completedSteps['completedSteps']['propertyDetail']) {
                                  percentage = 40
                                }
                                if (completedSteps['completedSteps']['rentableSpace']) {
                                  percentage = 50
                                }
                                if (completedSteps['completedSteps']['photos']) {
                                  percentage = 60
                                }
                                if (completedSteps['completedSteps']['facilitiesAndServices']) {
                                  percentage = 70
                                }
                                if (completedSteps['completedSteps']['availability']) {
                                  percentage = 80
                                }
                                if (completedSteps['completedSteps']['policies']) {
                                  percentage = 90
                                }
                                if (completedSteps['completedSteps']['financeAndLegal']) {
                                  percentage = 100
                                }
                                return (
                                  <>
                                    <div className='d-flex justify-content-between w-100 mt-auto'>
                                      <span className='fw-bold fs-6'>{t('Completion')}</span>
                                      <span className='fw-bolder fs-6'>{percentage}%</span>
                                    </div>
                                    <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                      <div
                                        className='bg-success rounded h-5px'
                                        role='progressbar'
                                        style={{ width: `${percentage}%` }}
                                      ></div>
                                    </div>
                                  </>
                                )
                              })}
                            </>
                          ) : (
                            <>
                              <div className='d-flex justify-content-between w-100 mt-auto'>
                                <span className='fw-bold fs-6'>{t('Completion')}</span>
                                <span className='fw-bolder fs-6'>0%</span>
                              </div>
                              <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                <div
                                  className='bg-success rounded h-5px'
                                  role='progressbar'
                                  style={{ width: '0%' }}
                                ></div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      {/* <!--end::Card header--> */}
                      {/* <!--begin::Card body--> */}
                      <div className='card-body'>
                        <div className='row'>
                          <div className='col-lg-12 my-5'>
                            <label className='d-flex text-start' data-kt-button='true'>
                              {/* <!--begin::Radio--> */}
                              <span className='form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1'>
                                <input
                                  className='form-check-input'
                                  type='checkbox'
                                  name='byDay'
                                  value='true'
                                  checked={isNonRefundable}
                                  onChange={(e) => {
                                    handleNonRefundableChange(e)
                                    removeError('isNonRefundable')
                                  }}
                                />
                              </span>
                              {/* <!--end::Radio--> */}
                              {/* <!--begin::Info--> */}
                              <span className='ms-5'>
                                <span className='fs-4 fw-bold text-gray-800 d-block'>
                                  {' '}
                                  {t('Non-refundable')}
                                </span>
                              </span>
                              {/* <!--end::Info--> */}
                            </label>
                            <label className='form-label'>
                              {t(
                                'Guest will pay the full amount if they cancel after reservation.'
                              )}
                            </label>
                          </div>
                          {isNonRefundable == false && (
                            <>
                              <div className='col-lg-6 my-3'>
                                <div className='row'>
                                  <div className='col-lg-12 my-5'>
                                    <label className='fs-5 form-label fw-semibold'>
                                      {t('How many days before arrival can guests')}{' '}
                                      <span className='fw-bolder'>
                                        {t('cancel their booking for free?')}
                                      </span>
                                    </label>
                                  </div>
                                  <div className='col-lg-12'>
                                    <ul className='nav nav-pills nav-fill'>
                                      <li className='nav-item'>
                                        <button
                                          className={`nav-link tab-link ${tab == '1' ? 'active' : ''
                                            }`}
                                          onClick={() => setTab('1')}
                                        >
                                          {t('1 Day')}
                                        </button>
                                      </li>
                                      <li className='nav-item'>
                                        <button
                                          className={`nav-link tab-link ${tab == '5' ? 'active' : ''
                                            }`}
                                          onClick={() => setTab('5')}
                                        >
                                          {t('5 Days')}
                                        </button>
                                      </li>
                                      <li className='nav-item'>
                                        <button
                                          className={`nav-link tab-link ${tab == '14' ? 'active' : ''
                                            }`}
                                          onClick={() => setTab('14')}
                                        >
                                          {t('14 Days')}
                                        </button>
                                      </li>
                                      <li className='nav-item'>
                                        <button
                                          className={`nav-link tab-link ${tab == '30' ? 'active' : ''
                                            }`}
                                          onClick={() => setTab('30')}
                                        >
                                          {t('30 Days')}
                                        </button>
                                      </li>
                                    </ul>
                                  </div>
                                  <div className='col-lg-12'>
                                    {tab == '1' && (
                                      <label className='fs-5 form-label cursor-pointer my-10 d-flex'>
                                        <i className='fa-regular fa-clock text-success fs-4 mt-1 mx-2'></i>{' '}
                                        <span>
                                          {t(`Guests love flexibility - free cancellation rates are generally the most booked rates on our site. Get your first booking sooner by allowing guestes to cancle up to 1 days before check-in.`)}
                                        </span>
                                      </label>
                                    )}
                                    {tab == '5' && (
                                      <label className='fs-5 form-label cursor-pointer my-10 d-flex'>
                                        <i className='fa-regular fa-clock text-success fs-4 mt-1 mx-2'></i>{' '}
                                        <span>
                                          {t(`Guests love flexibility - free cancellation rates are generally the most booked rates on our site. Get your first booking sooner by allowing guestes to cancle up to 5 days before check-in.`)}
                                        </span>
                                      </label>
                                    )}
                                    {tab == '14' && (
                                      <label className='fs-5 form-label cursor-pointer my-10 d-flex'>
                                        <i className='fa-regular fa-clock text-success fs-4 mt-1 mx-2'></i>{' '}
                                        <span>
                                          {t(`Guests love flexibility - free cancellation rates are generally the most booked rates on our site. Get your first booking sooner by allowing guestes to cancle up to 14 days before check-in.`)}
                                        </span>
                                      </label>
                                    )}
                                    {tab == '30' && (
                                      <label className='fs-5 form-label cursor-pointer my-10 d-flex'>
                                        <i className='fa-regular fa-clock text-success fs-4 mt-1 mx-2'></i>{' '}
                                        <span>
                                          {t(`Guests love flexibility - free cancellation rates are generally the most booked rates on our site. Get your first booking sooner by allowing guestes to cancle up to 30 days before check-in.`)}
                                        </span>
                                      </label>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className='col-lg-6 my-3'>
                                <div className='row'>
                                  <div className='col-lg-12 my-5'>
                                    <label className='fs-5 form-label fw-semibold'>
                                      {t('What are')}{' '}
                                      <span className='fw-bolder'>{t('the fees')}</span>{' '}
                                      {t(`if they
                                      cancel within these days before check in:`)}
                                    </label>
                                  </div>
                                  <div className='col-lg-6'>
                                    <label className='required fs-4 form-label'>
                                      {t('Days before check in')}
                                    </label>
                                  </div>
                                  <div className='col-lg-6'>
                                    <label className='required fs-4 form-label'>{t('Fee')}</label>
                                  </div>
                                  {fee.map((field, index) => (
                                    <div key={index} className='row'>
                                      <div className='col-lg-6 my-3'>
                                        <Select
                                          name='beforeCheckinDays[]'
                                          id='beforeCheckinDaysList'
                                          placeholder={t('Select Days')}
                                          isSearchable={true}
                                          isDisabled={field.day == '0' || field.day == '1'}
                                          options={filterDaysList(fee)}
                                          value={getInitialBeforeCheckinDaysList(tab).find(
                                            (option) => option.value === field.day
                                          )}
                                          onChange={(e: any) =>
                                            handleFieldChange(index, 'day', e.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg-6 my-3'>
                                        <Select
                                          name='percentage[]'
                                          id='percentageList'
                                          placeholder={t('Select Percentage')}
                                          isSearchable={true}
                                          options={filterPercentageList(fee)}
                                          value={
                                            initialPercentageList.find(
                                              (option) => option.value === field.percentage
                                            ) || null
                                          }
                                          onChange={(e: any) =>
                                            handleFieldChange(index, 'percentage', e.value)
                                          }
                                        />
                                      </div>
                                      {((index > 0 && tab == '1') || (index > 1 && tab != '1')) && (
                                        <div className='col-lg-12 d-flex justify-content-end my-3'>
                                          <button
                                            className='btn btn-danger mb-2'
                                            onClick={() => handleRemoveField(index)}
                                          >
                                            {t('Remove')}
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  ))}
                                  <div className='col-lg-12 d-flex justify-content-end my-3'>
                                    <button
                                      className='btn btn-success mb-2'
                                      onClick={handleAddField}
                                    >
                                      {t('Add More')}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                        {/* <!--end::Input group--> */}
                        {primaryLanguage == 'English' && (
                          <>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Cancellation Policy (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <div
                                  id='cancellationPolicyEN'
                                  ref={divRefEN}
                                  className='form-control h-200px'
                                  style={{ overflow: 'auto' }}
                                >
                                  {isNonRefundable == false && (
                                    <>
                                      <ul>
                                        <li>
                                          <span className='fw-bold text-dark'>
                                            Free cancellation:
                                          </span>{' '}
                                          You can cancel for free up to{' '}
                                          {cancellationDay[0]['cancellationDay'] == '1'
                                            ? cancellationDay[0]['cancellationDay'] + ' day'
                                            : cancellationDay[0]['cancellationDay'] + ' days'}{' '}
                                          before check-in. No charges will apply.
                                        </li>
                                        {cancellationDay[0]['fee'].map((fee) => {
                                          return (
                                            <li>
                                              If you cancel{' '}
                                              {fee['day'] == '0'
                                                ? 'less than 24 hours'
                                                : fee['day'] + ' days'}{' '}
                                              before check-in, you will be charged{' '}
                                              {fee['percentage']}% of the total booking price.
                                            </li>
                                          )
                                        })}
                                        <li>
                                          If you do not show up for your booking, no refund will be
                                          issued.
                                        </li>
                                        <li>
                                          Once you check in, no refund will be provided for any
                                          unused days or early check-out.
                                        </li>
                                      </ul>
                                    </>
                                  )}
                                  {isNonRefundable == true && (
                                    <>
                                      <ul>
                                        <li className='text-dark' style={{ fontWeight: 'bolder' }}>
                                          <span>Non-refundable</span>
                                        </li>
                                      </ul>
                                      <p>
                                        You will pay the full amount if you can cancel the
                                        reservation.
                                      </p>
                                    </>
                                  )}
                                </div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Cancellation Policy (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <div
                                  id='cancellationPolicyRU'
                                  ref={divRefRU}
                                  className='form-control h-200px'
                                  style={{ overflow: 'auto' }}
                                >
                                  {isNonRefundable == false && (
                                    <>
                                      <ul>
                                        <li>
                                          <span className='fw-bold text-dark'>
                                            Бесплатная отмена:
                                          </span>{' '}
                                          Вы можете отменить бронирование бесплатно за{' '}
                                          {cancellationDay[0]['cancellationDay']} дней до заезда.
                                          Плата не взимается.
                                        </li>
                                        {cancellationDay[0]['fee'].map((fee) => {
                                          return (
                                            <li>
                                              Если вы отмените бронирование{' '}
                                              {fee['day'] == '0'
                                                ? 'менее чем за 24 часа до'
                                                : 'за ' + fee['day'] + ' дней'}{' '}
                                              до заезда, с вас будет взиматься {fee['percentage']}%
                                              от общей стоимости бронирования.
                                            </li>
                                          )
                                        })}
                                        <li>
                                          Если вы не приедете в объект размещения или не
                                          воспользуетесь бронированием, возврат средств не
                                          производится.
                                        </li>
                                        <li>
                                          После регистрации заезда возврат средств за
                                          неиспользованные дни или ранний выезд не производится.
                                        </li>
                                      </ul>
                                    </>
                                  )}
                                  {isNonRefundable == true && (
                                    <>
                                      <ul>
                                        <li className='text-dark' style={{ fontWeight: 'bolder' }}>
                                          <span>Нет возврата</span>
                                        </li>
                                      </ul>
                                      <p>Вы заплатите полную сумму, если отмените бронирование.</p>
                                    </>
                                  )}
                                </div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Cancellation Policy (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <div
                                  id='cancellationPolicyUZ'
                                  ref={divRefUZ}
                                  className='form-control h-200px'
                                  style={{ overflow: 'auto' }}
                                >
                                  {isNonRefundable == false && (
                                    <>
                                      <ul>
                                        <li>
                                          <span className='fw-bold text-dark'>
                                            Bepul bekor qilish:
                                          </span>{' '}
                                          Bron sanasidan {cancellationDay[0]['cancellationDay']} kun
                                          oldin bepul bekor qilishingiz mumkin. Hech qanday to‘lov
                                          olinmaydi.
                                        </li>
                                        {cancellationDay[0]['fee'].map((fee) => {
                                          return (
                                            <li>
                                              Agar bron
                                              {fee['day'] == '0'
                                                ? 'ni 24 soatdan kam vaqt qolganida'
                                                : ' sanasidan ' + fee['day'] + ' kun oldin'}{' '}
                                              bekor qilsangiz, sizdan jami bron narxining{' '}
                                              {fee['percentage']}% ushlab qolinadi.
                                            </li>
                                          )
                                        })}
                                        <li>
                                          Agar siz bron sanasida manzilga kelmasangiz va
                                          foydalanmasangiz, to'lov qaytarilmaydi.
                                        </li>
                                        <li>
                                          Bron kunidan so'ng, foydalanilmagan kunlar uchun yoki erta
                                          chiqib ketilganligi uchun to'lovlar qaytarilmaydi.
                                        </li>
                                      </ul>
                                    </>
                                  )}
                                  {isNonRefundable == true && (
                                    <>
                                      <ul>
                                        <li className='text-dark' style={{ fontWeight: 'bolder' }}>
                                          <span>Qaytarilmaydi</span>
                                        </li>
                                      </ul>
                                      <p>
                                        Agar siz bronni bekor qilsangiz, to'lovingiz to'liq miqdorda
                                        ushlab qolinadi va qaytarib berilmaydi
                                      </p>
                                    </>
                                  )}
                                </div>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-12 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-5 form-label'>
                                  {t('User Guide (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <JoditEditor
                                  ref={editorRef}
                                  config={editorConfig}
                                  value={userGuideEN}
                                  onBlur={(newContent) => {
                                    setUserGuideEN(newContent)
                                    removeError('userGuideEN')
                                  }}
                                />
                                <div className='text-danger fw-bold'>{error[0].userGuideEN}</div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-12 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-5 form-label'>
                                  {t('User Guide (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <JoditEditor
                                  ref={editorRef}
                                  config={editorConfig}
                                  value={userGuideRU}
                                  onBlur={(newContent) => {
                                    setUserGuideRU(newContent)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-12 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-5 form-label'>{t('User Guide (Uzbek)')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <JoditEditor
                                  ref={editorRef}
                                  config={editorConfig}
                                  value={userGuideUZ}
                                  onBlur={(newContent) => {
                                    setUserGuideUZ(newContent)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            {/* <!--end::Input group--> */}
                          </>
                        )}
                        {primaryLanguage == 'Russian' && (
                          <>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 required form-label'>
                                  {t('Cancellation Policy (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                <div
                                  id='cancellationPolicyRU'
                                  ref={divRefRU}
                                  className='form-control h-200px'
                                  style={{ overflow: 'auto' }}
                                >
                                  {isNonRefundable == false && (
                                    <>
                                      <ul>
                                        <li>
                                          <span className='fw-bold text-dark'>
                                            Бесплатная отмена:
                                          </span>{' '}
                                          Вы можете отменить бронирование бесплатно за{' '}
                                          {cancellationDay[0]['cancellationDay']} дней до заезда.
                                          Плата не взимается.
                                        </li>
                                        {cancellationDay[0]['fee'].map((fee) => {
                                          return (
                                            <li>
                                              Если вы отмените бронирование{' '}
                                              {fee['day'] == '0'
                                                ? 'менее чем за 24 часа до'
                                                : 'за ' + fee['day'] + ' дней'}{' '}
                                              до заезда, с вас будет взиматься {fee['percentage']}%
                                              от общей стоимости бронирования.
                                            </li>
                                          )
                                        })}
                                        <li>
                                          Если вы не приедете в объект размещения или не
                                          воспользуетесь бронированием, возврат средств не
                                          производится.
                                        </li>
                                        <li>
                                          После регистрации заезда возврат средств за
                                          неиспользованные дни или ранний выезд не производится.
                                        </li>
                                      </ul>
                                    </>
                                  )}
                                  {isNonRefundable == true && (
                                    <>
                                      <ul>
                                        <li className='text-dark' style={{ fontWeight: 'bolder' }}>
                                          <span>Нет возврата</span>
                                        </li>
                                      </ul>
                                      <p>Вы заплатите полную сумму, если отмените бронирование.</p>
                                    </>
                                  )}
                                </div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Cancellation Policy (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                <div
                                  id='cancellationPolicyEN'
                                  ref={divRefEN}
                                  className='form-control h-200px'
                                  style={{ overflow: 'auto' }}
                                >
                                  {isNonRefundable == false && (
                                    <>
                                      <ul>
                                        <li>
                                          <span className='fw-bold text-dark'>
                                            Free cancellation:
                                          </span>{' '}
                                          You can cancel for free up to{' '}
                                          {cancellationDay[0]['cancellationDay'] == '1'
                                            ? cancellationDay[0]['cancellationDay'] + ' day'
                                            : cancellationDay[0]['cancellationDay'] + ' days'}{' '}
                                          before check-in. No charges will apply.
                                        </li>
                                        {cancellationDay[0]['fee'].map((fee) => {
                                          return (
                                            <li>
                                              If you cancel{' '}
                                              {fee['day'] == '0'
                                                ? 'less than 24 hours'
                                                : fee['day'] + ' days'}{' '}
                                              before check-in, you will be charged{' '}
                                              {fee['percentage']}% of the total booking price.
                                            </li>
                                          )
                                        })}
                                        <li>
                                          If you do not show up for your booking, no refund will be
                                          issued.
                                        </li>
                                        <li>
                                          Once you check in, no refund will be provided for any
                                          unused days or early check-out.
                                        </li>
                                      </ul>
                                    </>
                                  )}
                                  {isNonRefundable == true && (
                                    <>
                                      <ul>
                                        <li className='text-dark' style={{ fontWeight: 'bolder' }}>
                                          <span>Non-refundable</span>
                                        </li>
                                      </ul>
                                      <p>
                                        You will pay the full amount if you can cancel the
                                        reservation.
                                      </p>
                                    </>
                                  )}
                                </div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Cancellation Policy (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                <div
                                  id='cancellationPolicyUZ'
                                  ref={divRefUZ}
                                  className='form-control h-200px'
                                  style={{ overflow: 'auto' }}
                                >
                                  {isNonRefundable == false && (
                                    <>
                                      <ul>
                                        <li>
                                          <span className='fw-bold text-dark'>
                                            Bepul bekor qilish:
                                          </span>{' '}
                                          Bron sanasidan {cancellationDay[0]['cancellationDay']} kun
                                          oldin bepul bekor qilishingiz mumkin. Hech qanday to‘lov
                                          olinmaydi.
                                        </li>
                                        {cancellationDay[0]['fee'].map((fee) => {
                                          return (
                                            <li>
                                              Agar bron
                                              {fee['day'] == '0'
                                                ? 'ni 24 soatdan kam vaqt qolganida'
                                                : ' sanasidan ' + fee['day'] + ' kun oldin'}{' '}
                                              bekor qilsangiz, sizdan jami bron narxining{' '}
                                              {fee['percentage']}% ushlab qolinadi.
                                            </li>
                                          )
                                        })}
                                        <li>
                                          Agar siz bron sanasida manzilga kelmasangiz va
                                          foydalanmasangiz, to'lov qaytarilmaydi.
                                        </li>
                                        <li>
                                          Bron kunidan so'ng, foydalanilmagan kunlar uchun yoki erta
                                          chiqib ketilganligi uchun to'lovlar qaytarilmaydi.
                                        </li>
                                      </ul>
                                    </>
                                  )}
                                  {isNonRefundable == true && (
                                    <>
                                      <ul>
                                        <li className='text-dark' style={{ fontWeight: 'bolder' }}>
                                          <span>Qaytarilmaydi</span>
                                        </li>
                                      </ul>
                                      <p>
                                        Agar siz bronni bekor qilsangiz, to'lovingiz to'liq miqdorda
                                        ushlab qolinadi va qaytarib berilmaydi
                                      </p>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-12 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-5 required form-label'>
                                  {t('User Guide (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <JoditEditor
                                  ref={editorRef}
                                  config={editorConfig}
                                  value={userGuideRU}
                                  onBlur={(newContent) => {
                                    setUserGuideRU(newContent)
                                    removeError('userGuideRU')
                                  }}
                                />
                                <div className='text-danger fw-bold'>{error[0].userGuideRU}</div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-12 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-5 form-label'>User Guide (English)</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <JoditEditor
                                  ref={editorRef}
                                  config={editorConfig}
                                  value={userGuideEN}
                                  onBlur={(newContent) => {
                                    setUserGuideEN(newContent)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-12 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-5 form-label'>User Guide (Uzbek)</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <JoditEditor
                                  ref={editorRef}
                                  config={editorConfig}
                                  value={userGuideUZ}
                                  onBlur={(newContent) => {
                                    setUserGuideUZ(newContent)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            {/* <!--end::Input group--> */}
                          </>
                        )}
                        {primaryLanguage == 'Uzbek' && (
                          <>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 required form-label'>
                                  {t('Cancellation Policy (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                <div
                                  id='cancellationPolicyUZ'
                                  ref={divRefUZ}
                                  className='form-control h-200px'
                                  style={{ overflow: 'auto' }}
                                >
                                  {isNonRefundable == false && (
                                    <>
                                      <ul>
                                        <li>
                                          <span className='fw-bold text-dark'>
                                            Bepul bekor qilish:
                                          </span>{' '}
                                          Bron sanasidan {cancellationDay[0]['cancellationDay']} kun
                                          oldin bepul bekor qilishingiz mumkin. Hech qanday to‘lov
                                          olinmaydi.
                                        </li>
                                        {cancellationDay[0]['fee'].map((fee) => {
                                          return (
                                            <li>
                                              Agar bron
                                              {fee['day'] == '0'
                                                ? 'ni 24 soatdan kam vaqt qolganida'
                                                : ' sanasidan ' + fee['day'] + ' kun oldin'}{' '}
                                              bekor qilsangiz, sizdan jami bron narxining{' '}
                                              {fee['percentage']}% ushlab qolinadi.
                                            </li>
                                          )
                                        })}
                                        <li>
                                          Agar siz bron sanasida manzilga kelmasangiz va
                                          foydalanmasangiz, to'lov qaytarilmaydi.
                                        </li>
                                        <li>
                                          Bron kunidan so'ng, foydalanilmagan kunlar uchun yoki erta
                                          chiqib ketilganligi uchun to'lovlar qaytarilmaydi.
                                        </li>
                                      </ul>
                                    </>
                                  )}
                                  {isNonRefundable == true && (
                                    <>
                                      <ul>
                                        <li className='text-dark' style={{ fontWeight: 'bolder' }}>
                                          <span>Qaytarilmaydi</span>
                                        </li>
                                      </ul>
                                      <p>
                                        Agar siz bronni bekor qilsangiz, to'lovingiz to'liq miqdorda
                                        ushlab qolinadi va qaytarib berilmaydi
                                      </p>
                                    </>
                                  )}
                                </div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Cancellation Policy (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                <div
                                  id='cancellationPolicyRU'
                                  ref={divRefRU}
                                  className='form-control h-200px'
                                  style={{ overflow: 'auto' }}
                                >
                                  {isNonRefundable == false && (
                                    <>
                                      <ul>
                                        <li>
                                          <span className='fw-bold text-dark'>
                                            Бесплатная отмена:
                                          </span>{' '}
                                          Вы можете отменить бронирование бесплатно за{' '}
                                          {cancellationDay[0]['cancellationDay']} дней до заезда.
                                          Плата не взимается.
                                        </li>
                                        {cancellationDay[0]['fee'].map((fee) => {
                                          return (
                                            <li>
                                              Если вы отмените бронирование{' '}
                                              {fee['day'] == '0'
                                                ? 'менее чем за 24 часа до'
                                                : 'за ' + fee['day'] + ' дней'}{' '}
                                              до заезда, с вас будет взиматься {fee['percentage']}%
                                              от общей стоимости бронирования.
                                            </li>
                                          )
                                        })}
                                        <li>
                                          Если вы не приедете в объект размещения или не
                                          воспользуетесь бронированием, возврат средств не
                                          производится.
                                        </li>
                                        <li>
                                          После регистрации заезда возврат средств за
                                          неиспользованные дни или ранний выезд не производится.
                                        </li>
                                      </ul>
                                    </>
                                  )}
                                  {isNonRefundable == true && (
                                    <>
                                      <ul>
                                        <li className='text-dark' style={{ fontWeight: 'bolder' }}>
                                          <span>Нет возврата</span>
                                        </li>
                                      </ul>
                                      <p>Вы заплатите полную сумму, если отмените бронирование.</p>
                                    </>
                                  )}
                                </div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Cancellation Policy (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                <div
                                  id='cancellationPolicyEN'
                                  ref={divRefEN}
                                  className='form-control h-200px'
                                  style={{ overflow: 'auto' }}
                                >
                                  {isNonRefundable == false && (
                                    <>
                                      <ul>
                                        <li>
                                          <span className='fw-bold text-dark'>
                                            Free cancellation:
                                          </span>{' '}
                                          You can cancel for free up to{' '}
                                          {cancellationDay[0]['cancellationDay'] == '1'
                                            ? cancellationDay[0]['cancellationDay'] + ' day'
                                            : cancellationDay[0]['cancellationDay'] + ' days'}{' '}
                                          before check-in. No charges will apply.
                                        </li>
                                        {cancellationDay[0]['fee'].map((fee) => {
                                          return (
                                            <li>
                                              If you cancel{' '}
                                              {fee['day'] == '0'
                                                ? 'less than 24 hours'
                                                : fee['day'] + ' days'}{' '}
                                              before check-in, you will be charged{' '}
                                              {fee['percentage']}% of the total booking price.
                                            </li>
                                          )
                                        })}
                                        <li>
                                          If you do not show up for your booking, no refund will be
                                          issued.
                                        </li>
                                        <li>
                                          Once you check in, no refund will be provided for any
                                          unused days or early check-out.
                                        </li>
                                      </ul>
                                    </>
                                  )}
                                  {isNonRefundable == true && (
                                    <>
                                      <ul>
                                        <li className='text-dark' style={{ fontWeight: 'bolder' }}>
                                          <span>Non-refundable</span>
                                        </li>
                                      </ul>
                                      <p>
                                        You will pay the full amount if you can cancel the
                                        reservation.
                                      </p>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-12 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-5 required form-label'>
                                  {t('User Guide (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <JoditEditor
                                  ref={editorRef}
                                  config={editorConfig}
                                  value={userGuideUZ}
                                  onBlur={(newContent) => {
                                    setUserGuideUZ(newContent)
                                    removeError('userGuideUZ')
                                  }}
                                />
                                <div className='text-danger fw-bold'>{error[0].userGuideUZ}</div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-12 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-5 form-label'>
                                  {t('User Guide (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <JoditEditor
                                  ref={editorRef}
                                  config={editorConfig}
                                  value={userGuideRU}
                                  onBlur={(newContent) => {
                                    setUserGuideRU(newContent)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-12 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-5 form-label'>
                                  {t('User Guide (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <JoditEditor
                                  ref={editorRef}
                                  config={editorConfig}
                                  value={userGuideEN}
                                  onBlur={(newContent) => {
                                    setUserGuideEN(newContent)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            {/* <!--end::Input group--> */}
                          </>
                        )}
                        <div className='row'>
                          <div className='border border-2'></div>
                          <div className='col-lg-12 my-3'>
                            <label className='fs-3 form-label fw-bold'>{t('Opening Hours')}</label>
                          </div>

                          <div className='col-lg-12 '>
                            <span className='fw-bolder fs-5 form-label'>
                              *Note{' '}
                              <span className='fs-6 form-label'>
                                {' '}
                                {t(`If you don't add "opening hours" to any days of the week below, that
                                day will be considered as "Closed", "Unavailable for bookings"`)}
                              </span>
                            </span>
                          </div>
                        </div>
                        {/* <!--begin::Row--> */}
                        {openingHourData.map((dayData: any, dayIndex) => (
                          <div className='row align-items-center mb-4' key={dayIndex}>
                            {/* Day Name + Add Button (if empty) */}
                            <div className='col-lg-2 d-flex justify-content-between align-items-center'>
                               <h5 className='mt-lg-5'>
                                {t(dayData.day.charAt(0).toUpperCase() + t(dayData.day).slice(1).toLowerCase())}
                              </h5>
                              {/* {dayData.timeSlot.length === 0 && (
                                <button
                                  className='btn btn-success btn-sm'
                                  onClick={() => addTimeField(dayIndex)}
                                >
                                  {t('Add')}
                                </button>
                              )} */}
                            </div>
                            <div className='col-lg-2 d-flex align-items-center'>
                              <div className='form-check form-check-custom form-check-solid form-check-success form-switch'>
                                <input
                                  className='form-check-input cursor-pointer'
                                  type='checkbox'
                                  id={`flexSwitchCheckDefault${dayIndex}`}
                                  checked={dayData.isOpen == '1'}
                                  onChange={() => toggleDayOpen(dayIndex)}
                                />
                                <label
                                  className='form-check-label text-gray-700 fw-bold ms-2'
                                  htmlFor={`flexSwitchCheckDefault${dayIndex}`}
                                  data-bs-toggle='tooltip'
                                  title={
                                    dayData.isOpen == '1' ? 'Currently Open' : 'Currently Closed'
                                  }
                                >
                                  {dayData.isOpen == '1' ? t('Open') : t('Closed')}
                                </label>
                              </div>
                            </div>

                            {/* Is Open Switch */}

                            {/* Time Slots */}
                            <div className='col-lg-8'>
                              {dayData.timeSlot.map((timeSlot: any, timeIndex: any) => (
                                <div className='row align-items-end mb-2' key={timeIndex}>
                                  <div className='col-lg-5'>
                                    <label className='form-label fw-bold'>{t('Start Time')}</label>
                                    <Flatpickr
                                      data-enable-time
                                      value={moment(timeSlot.startTime, 'HH:mm:ss').format('HH:mm')}
                                      onChange={(date) => {
                                        const formattedTime = handleTimeChange2(date)
                                        handleInputChange(dayIndex, timeIndex, {
                                          target: { name: 'startTime', value: formattedTime },
                                        })
                                      }}
                                      options={{
                                        enableTime: true,
                                        noCalendar: true,
                                        dateFormat: 'H:i',
                                        time_24hr: true,
                                        minuteIncrement: 60,
                                        allowInput: false,
                                      }}
                                      className='form-control'
                                    />
                                  </div>

                                  <div className='col-lg-5'>
                                    <label className='form-label fw-bold'>{t('End Time')}</label>
                                    <Flatpickr
                                      data-enable-time
                                      value={moment(timeSlot.endTime, 'HH:mm:ss').format('HH:mm')}
                                      onChange={(date) => {
                                        const formattedTime = handleTimeChange2(date)
                                        handleInputChange(dayIndex, timeIndex, {
                                          target: { name: 'endTime', value: formattedTime },
                                        })
                                      }}
                                      options={{
                                        enableTime: true,
                                        noCalendar: true,
                                        dateFormat: 'H:i',
                                        time_24hr: true,
                                        minuteIncrement: 60,
                                        allowInput: false,
                                      }}
                                      className='form-control'
                                    />
                                  </div>

                                  <div className='col-lg-2 d-flex gap-2'>
                                    {/* Remove Button */}
                                    {(dayData.timeSlot.length > 1 ||
                                      (dayData.timeSlot.length === 1 && timeIndex === 0)) && (
                                        <button
                                          className='btn btn-danger btn-sm'
                                          onClick={() => removeTimeField(dayIndex, timeIndex)}
                                        >
                                          ✕
                                        </button>
                                      )}

                                    {/* Add Button */}
                                    {timeIndex === dayData.timeSlot.length - 1 && (
                                      <button
                                        className='btn btn-success btn-sm'
                                        onClick={() => addTimeField(dayIndex)}
                                      >
                                        +
                                      </button>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}

                        {/* <!--end::Row--> */}
                        <div className='row'>
                          <div className='border border-2'></div>
                          <div className='col-lg-12 my-3'>
                            <button className='btn btn-light-success' onClick={togglePolicy}>
                              {t('Add Custom Policy')}
                            </button>
                          </div>
                        </div>

                        {/* <!--end::Input group--> */}
                        {showPolicy &&
                          policies.map((policy, index) => (
                            <div className='row' key={index}>
                              {primaryLanguage == 'English' && (
                                <>
                                  <div className='col-lg-12'>
                                    <div className='row'>
                                      <div className='col-lg my-3'>
                                        <label className='required fs-4 form-label'>
                                          {t('Policy Title (English)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleEN'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.en_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'en_title', e.target.value)
                                          }
                                        />
                                        {errors[index]?.titleEN && (
                                          <div className='text-danger fw-bold'>
                                            {errors[index].titleEN}
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Policy Title (Russian)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleRU'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.ru_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'ru_title', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className=' fs-4 form-label'>
                                          {t('Policy Title (Uzbek)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleUZ'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.uz_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'uz_title', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg-2'></div>
                                    </div>
                                    <div className='row'>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Policy Name (English)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='policyNameEN'
                                          placeholder={t('Policy Name')}
                                          className='form-control mb-2'
                                          value={policy.en_name}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'en_name', e.target.value)
                                          }
                                        />
                                        {errors[index]?.policyNameEN && (
                                          <div className='text-danger fw-bold'>
                                            {errors[index].policyNameEN}
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Policy Name (Russian)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='policyNameRU'
                                          placeholder={t('Policy Name')}
                                          className='form-control mb-2'
                                          value={policy.ru_name}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'ru_name', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Policy Name (Uzbek)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='policyNameUZ'
                                          placeholder={t('Policy Name')}
                                          className='form-control mb-2'
                                          value={policy.uz_name}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'uz_name', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg-2'></div>
                                    </div>
                                    <div className='row'>
                                      <div className='col-lg my-3'>
                                        <label className='required fs-4 form-label'>
                                          {t('Description (English)')}
                                        </label>
                                        <textarea
                                          name='descriptionEN'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.en_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'en_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                        {errors[index]?.descriptionEN && (
                                          <div className='text-danger fw-bold'>
                                            {errors[index].descriptionEN}
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Description (Russian)')}
                                        </label>
                                        <textarea
                                          name='descriptionRU'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.ru_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'ru_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Description (Uzbek)')}
                                        </label>
                                        <textarea
                                          name='descriptionUZ'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.uz_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'uz_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                      </div>
                                      <div className='col-lg-2 d-flex justify-content-lg-start justify-content-end align-items-end my-3'>
                                        {index !== 0 && (
                                          <button
                                            className='btn btn-danger mb-2'
                                            onClick={() => handleRemovePolicy(index)}
                                          >
                                            X
                                          </button>
                                        )}
                                        <button
                                          className='btn btn-success mb-2'
                                          onClick={handleAddPolicy}
                                        >
                                          +
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                              {primaryLanguage == 'Russian' && (
                                <>
                                  <div className='col-lg-12'>
                                    <div className='row'>
                                      <div className='col-lg my-3'>
                                        <label className='required fs-4 form-label'>
                                          {t('Policy Title (Russian)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleRU'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.ru_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'ru_title', e.target.value)
                                          }
                                        />
                                        {errors[index]?.titleRU && (
                                          <div className='text-danger fw-bold'>
                                            {errors[index].titleRU}
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Policy Title (English)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleEN'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.en_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'en_title', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Policy Title (Uzbek)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleUZ'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.uz_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'uz_title', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg-2'></div>
                                    </div>
                                    <div className='row'>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label required'>
                                          {t('Policy Name (Russian)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='policyNameRU'
                                          placeholder={t('Policy Name')}
                                          className='form-control mb-2'
                                          value={policy.ru_name}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'ru_name', e.target.value)
                                          }
                                        />
                                        {errors[index]?.policyNameRU && (
                                          <div className='text-danger fw-bold'>
                                            {errors[index].policyNameRU}
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label '>
                                          {t('Policy Name (English)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='policyNameEN'
                                          placeholder={t('Policy Name')}
                                          className='form-control mb-2'
                                          value={policy.en_name}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'en_name', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Policy Name (Uzbek)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='policyNameUZ'
                                          placeholder={t('Policy Name')}
                                          className='form-control mb-2'
                                          value={policy.uz_name}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'uz_name', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg-2'></div>
                                    </div>
                                    <div className='row'>
                                      <div className='col-lg my-3'>
                                        <label className='required fs-4 form-label'>
                                          {t('Description (Russian)')}
                                        </label>
                                        <textarea
                                          name='descriptionRU'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.ru_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'ru_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                        {errors[index]?.descriptionRU && (
                                          <div className='text-danger fw-bold'>
                                            {errors[index].descriptionRU}
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Description (English)')}
                                        </label>
                                        <textarea
                                          name='descriptionEN'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.en_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'en_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Description (Uzbek)')}
                                        </label>
                                        <textarea
                                          name='descriptionUZ'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.uz_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'uz_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                      </div>
                                      <div className='col-lg-2 d-flex justify-content-lg-start justify-content-end align-items-end my-3'>
                                        {index !== 0 && (
                                          <button
                                            className='btn btn-danger mb-2'
                                            onClick={() => handleRemovePolicy(index)}
                                          >
                                            X
                                          </button>
                                        )}
                                        <button
                                          className='btn btn-success mb-2'
                                          onClick={handleAddPolicy}
                                        >
                                          +
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                              {primaryLanguage == 'Uzbek' && (
                                <>
                                  <div className='col-lg-12'>
                                    <div className='row'>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label required'>
                                          {t('Policy Title (Uzbek)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleUZ'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.uz_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'uz_title', e.target.value)
                                          }
                                        />
                                        {errors[index]?.titleUZ && (
                                          <div className='text-danger fw-bold'>
                                            {errors[index].titleUZ}
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className=' fs-4 form-label'>
                                          {t('Policy Title (Russian)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleRU'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.ru_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'ru_title', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Policy Title (English)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleEN'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.en_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'en_title', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg-2'></div>
                                    </div>
                                    <div className='row'>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label required'>
                                          {t('Policy Name (Uzbek)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='policyNameUZ'
                                          placeholder={t('Policy Name')}
                                          className='form-control mb-2'
                                          value={policy.uz_name}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'uz_name', e.target.value)
                                          }
                                        />
                                        {errors[index]?.policyNameUZ && (
                                          <div className='text-danger fw-bold'>
                                            {errors[index].policyNameUZ}
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Policy Name (Russian)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='policyNameRU'
                                          placeholder={t('Policy Name')}
                                          className='form-control mb-2'
                                          value={policy.ru_name}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'ru_name', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label '>
                                          {t('Policy Name (English)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='policyNameEN'
                                          placeholder={t('Policy Name')}
                                          className='form-control mb-2'
                                          value={policy.en_name}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'en_name', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg-2'></div>
                                    </div>
                                    <div className='row'>
                                      <div className='col-lg my-3'>
                                        <label className='required fs-4 form-label'>
                                          {t('Description (Uzbek)')}
                                        </label>
                                        <textarea
                                          name='descriptionUZ'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.uz_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'uz_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                        {errors[index]?.descriptionUZ && (
                                          <div className='text-danger fw-bold'>
                                            {errors[index].descriptionUZ}
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Description (Russian)')}
                                        </label>
                                        <textarea
                                          name='descriptionRU'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.ru_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'ru_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Description (English)')}
                                        </label>
                                        <textarea
                                          name='descriptionEN'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.en_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'en_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                      </div>
                                      <div className='col-lg-2 d-flex justify-content-lg-start justify-content-end align-items-end my-3'>
                                        {index !== 0 && (
                                          <button
                                            className='btn btn-danger mb-2'
                                            onClick={() => handleRemovePolicy(index)}
                                          >
                                            X
                                          </button>
                                        )}
                                        <button
                                          className='btn btn-success mb-2'
                                          onClick={handleAddPolicy}
                                        >
                                          +
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          ))}
                      </div>
                      {/* <!--end::Card body--> */}
                    </div>
                    {/* <!--end::Pricing--> */}
                  </div>
                </div>
                {/* <!--end::Tab pane--> */}
              </div>
              {/* <!--end::Tab content--> */}
              <div className='d-flex justify-content-end'>
                {/* <!--begin::Button--> */}
                <button
                  type='button'
                  disabled={disable}
                  className='btn btn-primary'
                  onClick={addSpacePolicies}
                >
                  <span className='indicator-label'>{t('Next')}</span>
                  {loading && (
                    <span
                      className='spinner-border spinner-border-sm mx-2'
                      role='status'
                      aria-hidden='true'
                    ></span>
                  )}
                </button>
                {/* <!--end::Button--> */}
              </div>
            </div>
            {/* <!--end::Main column--> */}
          </div>
          {/* <!--end::Form--> */}
        </div>
        {/* <!--end::Content--> */}
      </div>
    </>
  )
}

export { AddSpacePolicies }
